import type { FeatureManifest } from '@/app/registry';
import { CONTEXTS, lazyView } from '@/app/registry';
import { profileRoutes } from './routes';

export const profileManifest: FeatureManifest = {
  id: 'profile',
  contexts: [CONTEXTS.PROFILE, CONTEXTS.PROFILE_EDIT],

  routes: [
    {
      zone: 'authenticated',
      routes: profileRoutes,
      errorFallbackLabel: 'Profil',
    },
  ],

  centerView: {
    [CONTEXTS.PROFILE]: lazyView(() => import('./views/ProfileView'), 'ProfileView'),
    [CONTEXTS.PROFILE_EDIT]: lazyView(() => import('./views/EditProfileView'), 'EditProfileView'),
  },

  // Note : pas de `navigation` — l'accès profil est rendu dans le `Header`
  // global (haut-droite, cf. `Header.tsx`). Les settings occupent désormais
  // le bas du rail latéral (cf. `settings/manifest.ts`).
};
